<template>
    <div v-if="person">

    </div>
</template>

<script>
    import Person from "../Person";
    import PersonItem from "../personas/PersonItem";

    export default {
        components: {
            PersonItem,
            Person},
        props: ['id'],
        name: "expanded-item-table",
        data() {
            return{
                person: null
            }
        },
        firestore() {
            return {
                person: this.$db.collection('forms').doc('inscripciones').collection('people').doc(this.id)
            }
        },
        created() {
            console.log(this.id)
        }
    }
</script>

<style scoped>

</style>